const WidgetHiddenPaths = [
  '/',
  'blog',
  'mortgage',
  'insurance',
  'home-services',
  'relocation',
  'account',
  'results'
];

const matchesHiddenPath = (pathname, hiddenPath) =>
  hiddenPath.startsWith('/') ? pathname === hiddenPath : pathname.includes(hiddenPath);

const isHiddenPath = (pathname) =>
  WidgetHiddenPaths.some((hiddenPath) => matchesHiddenPath(pathname, hiddenPath));

const isAgentDetailPage = (pathname) => pathname.startsWith('/agent');

const isListingDetailPage = (pathname) => pathname.includes('listing');

const listingHidesChat = (query, isSibcyListing) =>
  Boolean(isSibcyListing) || Boolean(query?.agentid) || Boolean(query?.tourModal);

export const isChatHidden = ({ pathname, query, isSibcyListing }) =>
  isHiddenPath(pathname) ||
  isAgentDetailPage(pathname) ||
  (isListingDetailPage(pathname) && listingHidesChat(query, isSibcyListing));
